import RecurringTransferSuccess from '../../../banking/components/transfers/recurring/setup-steps/RecurringTransferSuccess';

const RecurringTransferSuccessPage = () => {
    return <RecurringTransferSuccess />;
};

export default RecurringTransferSuccessPage;
